import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { cardTypeNames, cardTypeImages } from 'core/modules/Instore2/utils/cardTypes';

function SupportedCards({ shouldShowSupportedCards }) {
  if (!shouldShowSupportedCards) {
    return null;
  }

  return (
    <div className="mn_supportedCards">
      <span>In-store supports:</span>
      <span className="mn_cardsList">
        <img src={cardTypeImages.MASTERCARD} alt={cardTypeNames.MASTERCARD} />
        <img src={cardTypeImages.VISA} alt={cardTypeNames.VISA} />
        <img src={cardTypeImages.AMEX} alt={cardTypeNames.AMEX} />
      </span>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><SupportedCards {...props} /></ComponentErrorBoundary>;
